import type { SizesString } from '@/app/components/media/app-image/shared/image-size-types';
import {
  SPARTAN_ENGINE_SPEC_LABELS,
  SPARTAN_ENGINE_SPEC_UNITS,
} from '@/app/lcv/components/sections/spartan/shared/engine-spec/constants';
import type { SpartanEngineKey } from '@/services/spartan/types';

export const SPARTAN_PRODUCT_ENGINE_LABELS = {
  detail: 'ดูรายละเอียดเครื่องยนต์',
  engineTabs: 'เครื่องยนต์',
} as const;

/** Canonical tab/hero labels keyed by engine — do not duplicate in static engine data. */
export const SPARTAN_ENGINE_DISPLAY_LABELS = {
  '2.2': {
    tabLabel: '2.2 Ddi MAXFORCE',
    lineupTabLabel: '2.2 MAXFORCE',
    heroLabel: '2.2',
  },
  '3.0': {
    tabLabel: '3.0 Ddi MAXFORCE',
    lineupTabLabel: '3.0 MAXFORCE',
    heroLabel: '3.0',
  },
  '2.2 Biturbo': {
    tabLabel: '2.2 Ddi Biturbo',
    lineupTabLabel: '2.2 Biturbo',
    heroLabel: '2.2 Biturbo',
  },
} as const satisfies Record<
  SpartanEngineKey,
  { tabLabel: string; lineupTabLabel: string; heroLabel: string }
>;

export const SPARTAN_PRODUCT_ENGINE_SPEC_LABELS = {
  ...SPARTAN_ENGINE_SPEC_LABELS,
  fuelEconomy: 'ประหยัดน้ำมัน*',
} as const;

export const SPARTAN_PRODUCT_ENGINE_SPEC_UNITS = {
  ...SPARTAN_ENGINE_SPEC_UNITS,
  fuelEconomy: 'km/L',
} as const;

/** Intrinsic logo sizes — mobile 296×72, desktop 404×80. */
export const SPARTAN_PRODUCT_ENGINE_LOGO = {
  mobile: { width: 296, height: 72 },
  desktop: { width: 404, height: 80 },
} as const;

/** Layout width of the mobile logo: full card content up to `max-w-101` (404px). */
export const SPARTAN_PRODUCT_ENGINE_LOGO_MOBILE_SIZES =
  '(min-width: 480px) 404px, calc(100vw - 64px)' as const satisfies SizesString;

export const SPARTAN_PRODUCT_ENGINE_LOGO_DESKTOP_WIDTHS = [828, 1280] as const;

export const SPARTAN_PRODUCT_ENGINE_MEDIA_PRELOAD_OFFSET = '0px 0px 24px 0px';

export const SPARTAN_PRODUCT_ENGINE_REVEAL_SCROLL_OFFSET = '12%,0';

/** Remark sits below the block — reveal as soon as it enters the viewport. */
export const SPARTAN_PRODUCT_ENGINE_REMARK_REVEAL_SCROLL_OFFSET = '0%,0';

export const SPARTAN_PRODUCT_ENGINE_MEDIA_READY_TIMEOUT_MS = 1500;

export const SPARTAN_PRODUCT_ENGINE_SWITCH_DURATION_MS = {
  out: 120,
  in: 600,
} as const;
